var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-button-container",style:(_vm.marginStyle)},[_vm._m(0),_c('div',{staticClass:"google-button-logo"},[_c('GoogleIcon')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-button-text"},[_c('p',[_vm._v("Sign in with Google")])])
}]

export { render, staticRenderFns }